<template>
  <div class="container">
    <!-- 面包屑导航 -->
    <div class="breadcrumb"> <navbar></navbar></div>
    <div class="content page-title">
      <h2>{{ pageTitle }}</h2>
    </div>
    <div class="content">
      <h4>基础信息</h4>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="details-form">
        <el-form-item label="分享路径" prop="path">
          <el-select v-model="ruleForm.path" placeholder="请选择分享路径">
            <el-option
                v-for="item in dictionaries.share_config_path"
                :key="item.dictId"
                :label="item.dictName"
                :value="item.dictId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分享平台" prop="platformId">
          <el-select filterable v-model="ruleForm.platformId" placeholder="请选择分享平台">
            <el-option
                v-for="item in platformList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分享终端" prop="platform">
          <el-select v-model="ruleForm.platform" placeholder="请选择分享终端">
            <el-option
                v-for="item in dictionaries.share_config_platform"
                :key="item.dictId"
                :label="item.dictName"
                :value="item.dictId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分享链接" prop="url">
          <el-input v-model="ruleForm.url" placeholder="请输入对应的跳转链接"></el-input>
        </el-form-item>
        <el-form-item label="分享图片" prop="img">
          <el-upload
              class="avatar-uploader"
              action=""
              accept="image/*"
              :http-request="uploadFile"
              :auto-upload="true"
              :show-file-list="false"
              :before-upload="beforeAvatarUpload"
              ref="upload"
              >
            <img v-if="ruleForm.img" :src="ruleForm.img" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <!-- <p>尺寸500*400，2M以内</p> -->
          <p>2M以内</p>
        </el-form-item>
        <el-form-item label="分享标题" prop="title">
          <el-input v-model="ruleForm.title" placeholder="文案最多可以输入14个字，请留意" maxlength="14" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="分享文案" prop="content">
          <el-input v-model="ruleForm.content" placeholder="文案最多可以输入20个字，请留意" maxlength="20" show-word-limit></el-input>
        </el-form-item>
        <el-form-item class="operation-button">
          <el-button type="primary" plain @click="submitForm('cancel')">取消</el-button>
          <el-button type="warning" @click="submitForm('preview')">预览</el-button>
          <el-button type="primary" @click="submitForm('save')">保存</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--========================== el-dialog =================================-->
    <el-dialog
        :title="dialog.title"
        :visible.sync="dialog.visible"
        :width="dialog.width"
        :append-to-body="true"
        :custom-class="dialog.type === 'modifyState'? 'modify-state' : ''"
    >
      <template>
        <preview :previewObj="preview"></preview>
      </template>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitDialog">返回</el-button>
      </div>

    </el-dialog>
    <!--========================== el-dialog end =================================-->
  </div>
</template>

<script>
import common from './mixins/common.js'
import navbar from '@/components/navbar.vue'
import preview from './components/preview.vue'
import { ref, reactive } from '@vue/composition-api'
// console.log(ref, reactive)
export default {
  mixins: [common],
  components: { navbar, preview },
  watch: {
    $route: {
      handler (val, oldVal) {
        if (val.query.type === "edit" && val.query.id) {
          // console.log('val.query', val.query)
          this.fetchData (val.query.id)
        } else {
          this.$nextTick(() => {
            this.$refs['ruleForm'].resetFields();
          })
        }
      },
      immediate: true
      // deep: true
    },
  },
  data () {
    return {
      platformList: [], // 平台列表
      dictionaries: { // 字典数据
        share_config_path: [], // 分享路径
        share_config_platform: [] // 分享平台
      },
      pageTitle: '新增路径',
      ruleForm: {
        title: '',
        content: '',
        img: '',
        path: '',
        platformId: '',
        platform: '',
        url: ''
      },
      rules: {
        title: [
          { required: true, message: '请输入分享标题', trigger: 'blur' },
          { min: 1, max: 14, message: '长度在 1 到 14 个字符', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '请输入分享方案', trigger: 'blur' },
          { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' }
        ],
        img: [
          { required: true, message: '请上传图片', trigger: 'change' }
        ],
        path: [
          { required: true, message: '请选择路径', trigger: 'change' }
        ],
        platform: [
          { required: true, message: '请选择平台', trigger: 'change' }
        ],
        url: [
          { required: true, message: '请输入分享链接', trigger: 'blur' }
        ]
      },
      rQuery: {}
    }
  },
  mounted () {},
  created () {
    this.getPlatformList()
    this.rQuery = this.$route.query
    // if (this.$route.query.type === 'add') { for (const type in this.dictionaries) { this.getDictionaries(type) } }
    for (const type in this.dictionaries) { this.getDictionaries(type) }
  },
  methods: {
    // 获取平台列表
    getPlatformList() {
      const params = {}
      this.$api.platformDataList(params).then((res) => {
        this.platformList = res.data
      }).catch((err) => {
        console.log(err)
      })
    },
    getDictionaries (type) {
      return new Promise(resolve => {
        if (type && this.dictionaries[type].length > 0) { return }
        const params = { groupId: type }
        this.$api.dictionaries(params).then((res) => {
          this.dictionaries[type] = res.data
          resolve(res.data)
        }).catch((err) => {
          console.log(err)
        })
      });
    },
    async fetchData (id) {
      // for (const type in this.dictionaries) { await this.getDictionaries(type) }
      let params = { id }
      this.$api.shareList(params).then((res) => {
        if (res.code === 0) {
          this.ruleForm = Object.assign({}, res.data.list[0])
          // this.ruleForm.path = this.dictionaries.share_config_path.find(e => { return e.dictName === res.data[0].path }).dictId
          // this.ruleForm.platform = this.dictionaries.share_config_platform.find(e => { return e.dictName === res.data[0].platform }).dictId
          this.ruleForm.path = this.ruleForm.path.toString()
          this.ruleForm.platform = this.ruleForm.platform.toString()
        } else {
          console.log('shareList - 失败', res)
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    actionOperation (obj) {
      const { type, row } = obj
      switch (type) {
        case 'preview':
          console.log('actionOperation 预览', row)
          this.preview = {
            title: row.name, image: row.mainImage, content: row.content,
            logo: 'http://app.jiuhangyunxuan.com/static/img/loginLogo.37e7e255.png',
            platform: '九航云选', inviter: 'xxx', grade: '黄金' }
          break
        case 'edit':
          console.log('actionOperation 编辑', row)
          break
        default: // delete
          console.log('actionOperation 删除', row)
      }
      this.showDialog(row)
    },
    async beforeAvatarUpload (file) {
      const state = await this.checkImg(file)
      if (!state) {this.ruleForm.img = ''}
      return state
    },
    async uploadFile (e){
      const file = e.file
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) { this.$message.error('上传图片大小不能超过 2MB!'); return console.log('上传图片大小不能超过 2MB!') }
      const checkImg = await this.checkImg(file)
      console.log('checkImg', checkImg)
      if (!checkImg) {
        this.$message.error("请上传 500*400 px 的图片！");
        this.ruleForm.img = ''
        return console.log('上传图片大小不能超过 10KB!')
      } else {
        const params = new FormData()
        params.append('file', file) // 图片
        console.log(params)
        this.$api.uploadFiles(params).then(res => {
          if (res.code === 0) {
            this.$message.success('上传成功')
            this.ruleForm.img = this.ImgHttps + res.data.url
            // this.$emit('getUrl', this.imageUrl)
          } else {
            this.$message.error('上传失败')
          }
        })
      }
    },
    async submitForm (type) {
      const t = new Date().getTime()
      const validateState = await this.validateForm()
      console.log('validateState', validateState)
      switch (type) {
        case 'cancel':
          this.$refs['ruleForm'].resetFields();
          this.$router.push({ path:'/share/manage', query: { t } })
          break
        case 'preview':
          if (validateState) {
            this.mergePreview()
          } else {
            this.$message("请完善内容再预览！");
            console.log('请完善内容！')
          }
          break
        default: // save
          if (validateState) {
            const params = Object.assign({}, this.ruleForm)
            if (this.rQuery.type === 'add' && params.id) {delete params.id}
            this.$api.shareEdit(params).then((res) => {
              if (res.code === 0) {
                this.$refs['ruleForm'].resetFields();
                // this.fetchData()
                console.log('shareEdit - 成功', res)
                this.$notify({
                  title: '成功', message: '操作成功!',
                  type: 'success', duration: 3000
                })
                const t = new Date().getTime()
                this.$router.push({ path:'/share/manage', query: { t } })
              } else {
                console.log('shareEdit - 失败', res)
              }
            }).catch((err) => {
              console.log(err)
            })
          }
      }
    },
    validateForm () {
      return new Promise(resolve => {
        this.$refs['ruleForm'].validate((valid) => {
          resolve(valid)
        });
      });
    },
    checkImg (file) {
      return new Promise(resolve => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (theFile) => {
          const image = new Image();
          image.src = theFile.target.result;
          image.onload = () => {
            /*
            const { width, height } = image;
            if(width > 500 || height > 400) {
              console.log(width, height)
              resolve(false)
            } else {
              console.log(width, height)
              resolve(true)
            }
            */
            resolve(true)
          };
        };

      });
    },
    mergePreview(){
      const ruleForm = this.ruleForm
      const platform = this.dictionaries.share_config_platform.find(e => { return e.dictId === ruleForm.platform }).dictName
      console.log('platform', platform)
      this.preview = {
        title: ruleForm.title, image: ruleForm.img, content: ruleForm.content,
        logo: 'http://app.jiuhangyunxuan.com/static/img/loginLogo.37e7e255.png',
        platform, inviter: 'xxx', grade: '黄金' }
      this.showDialog()
    }

  }
}
</script>
<style scoped lang="scss">
//@import "./manage.scss";

.content{
  padding-bottom: 20px!important;
}
.details-form{
  max-width: 670px;
  margin-bottom: 20px;
  .el-form-item{
    margin-bottom: 20px;
  }
}

.operation-button{
  margin-top: 60px;
  .el-button{
    width: 176px;
    height: 48px;
    border-radius: 4px;
    border: none;
    font-size: 18px;
    font-weight: 400;
  }
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
:deep(.el-upload) {
  border: 1px dashed #d9d9d9;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

:deep(.el-dialog__footer){
  border-top: 1px solid #D9D9D9!important;
  .dialog-footer{

    text-align: center;
    .el-button{
      width: 120px;
      height: 36px;
      border-radius: 4px;
      color: #ffffff;
      background: #4168E7;
      border: none;
    }
    .el-button + .el-button{
      margin-left: 24px;
    }
  }
}
</style>
